export default  function toggleFooterItems(){

  var footerItems = document.querySelectorAll('.footer__item');
  for(var i = 0; i < footerItems.length; i++){

    let footerItem = footerItems[i].querySelector('.footer__heading');

    footerItem.addEventListener('click', function(event) {
      this.parentElement.classList.toggle('active');
    });
  }
}